import clsx from 'clsx';
import { TextareaHTMLAttributes } from 'react';

import style from './joyTextArea.module.scss';

const JoyTextArea = (props: TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  return (
    <div className={clsx(style.textAreaWrapper, props.disabled && style.disabled)}>
      <textarea {...props} data-hasValue={props.value !== '' && props.value != null} />
    </div>
  );
};

export default JoyTextArea;
